import React from 'react';

import { findStateName } from 'lib/helpers/utility';

export default function Row({ row, onClick, states }) {
  return (
    <div
      className="flex cursor-pointer justify-between gap-3 rounded-md bg-primary-50 p-3"
      onClick={onClick}>
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-3">
          <label className="font-bold">Name:</label>
          <span className="ml-auto">{row.bill_name}</span>
        </div>
        <div className="flex items-center gap-3">
          <label className="font-bold">NPI:</label>
          <span className="ml-auto">{row.bill_npi}</span>
        </div>
        <div className="flex items-center gap-3">
          <label className="font-bold">Tax ID:</label>
          <span className="ml-auto">{row.bill_taxid}</span>
        </div>
        <div className="flex items-center gap-3">
          <label className="font-bold">Tax ID Type:</label>
          <span className="ml-auto">{row.bill_taxid_type}</span>
        </div>
        <div className="flex items-center gap-3">
          <label className="font-bold">Taxonomy:</label>
          <span className="ml-auto">{row.bill_taxonomy}</span>
        </div>
        <div className="flex items-center gap-3">
          <label className="font-bold">Atypical ID:</label>
          <span className="ml-auto">{row.bill_id}</span>
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-3">
          <label className="font-bold">Address 1:</label>
          <span className="ml-auto">{row.bill_addr_1}</span>
        </div>
        <div className="flex items-center gap-3">
          <label className="font-bold">Address 2:</label>
          <span className="ml-auto">{row.bill_addr_2}</span>
        </div>
        <div className="flex items-center gap-3">
          <label className="font-bold">City:</label>
          <span className="ml-auto">{row.bill_city}</span>
        </div>
        <div className="flex items-center gap-3">
          <label className="font-bold">State:</label>
          <span className="ml-auto">{findStateName({ states, stateId: row.bill_state })}</span>
        </div>
        <div className="flex items-center gap-3">
          <label className="font-bold">Zip:</label>
          <span className="ml-auto">{row.bill_zip?.replace(/^(\d{5})(\d{4})$/, '$1-$2')}</span>
        </div>
        <div className="flex items-center gap-3">
          <label className="font-bold">Phone:</label>
          <span className="ml-auto">{row.bill_phone}</span>
        </div>
      </div>
    </div>
  );
}
